import { useState, useEffect } from "react";

/**
 * Debounce a value by delaying its update until after a specified delay
 *
 * @param value The value to debounce
 * @param delay Delay in milliseconds
 * @returns Debounced value
 */
function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);

    return () => clearTimeout(timer); // Cleanup on value/delay change
  }, [value, delay]);

  return debouncedValue;
}

export default useDebounce;
